import { fromJS } from 'immutable';

const initialState = fromJS({
  buyAndSupplierWizardStepper: 0,
  addRatesStepper: 0,
  addRateSetStepper: 0,
  addProductsStepper: 0,
  specialOffersStepper: 0,
  ratesWizardForMulitpleProduct: 0,
  addExtraStepper: 0,
  importFromTemplateStepper: 0,
});

function steppers(state = initialState, { type, payload }) {
  switch (type) {
    case 'CHANGE_STEPPER_WIZARD_STEP':
      return state.set(payload.stepperWizardName, payload.componentIndex);
    case 'CHANGE_STEP_STATE':
      if (payload.toClearAddProductW2) return state.set('ratesWizardForMulitpleProduct', 0);
      return state;
    case 'CONTRACT_PRODUCT_UPDATED':
    case 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD':
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
      return initialState;
    case 'REMOVE_RATE_SET_FROM_SEASON_WHEN_GO_BACK':
      return state.set('addRatesStepper', 2);
    case 'ADD_RATE_SET_TO_SEASON':
      return state.set('addRatesStepper', 3);
    case 'PRODUCTS_SAVED_GO_TO_BILLING':
      return state.set('addProductsStepper', 0).set('addRatesStepper', 0).set('addRateSetStepper', 0);
    case 'ADD_CHECKED_PRODUCTS_TO_ADD_PRODUCT_WIZARD':
      return state.set('addProductsStepper', 2);
    case '{rates-draft} MANAGE_EXTRAS_OFFERS_SUCCESS':
      return state.set('specialOffersStepper', 0)
        .set('addExtraStepper', 0);
    case 'CLEAR_ADD_RATE_SET_WIZARD':
      return state.set('addRateSetStepper', 0);
    default:
      return state;
  }
}

export default steppers;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/steppers/steppers-reducer.js